const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the user timeline component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Events} Events the resource defined to manage Events
 */
app.directive('userUpcomingEvents', ['Application', 'Authorization', 'Events', '$translate', function (Application, Authorization, Events, $translate) {
    return {
      restrict: 'E',
      replace: true,
      template: require('../../templates/directives/user-upcoming-events.html'),
      controller: function () {
        var self = this;
        self.getError = Application.notifications.getError;
        self.getSuccess = Application.notifications.getSuccess;
        self.navigation = Application.navigation;

        var parseEvents = function(events) {
          var userId = Authorization.getAuthToken().user._id.toString();
          var attendingBlock = {};
          var attending = [];
          var otherEvents = [];

          for (var i = 0; i < events.length; i++) {
            events[i].start = moment(events[i].start_date).format('MMMM Do, YYYY');
            for (var j = 0; j < events[i].attendees.length; j++) {
              if (events[i].attendees[j].toString() === userId) {
                attending.push(events[i]);
                attendingBlock[events[i]._id] = true;
                break;
              }
            }
            if (!attendingBlock[events[i]._id]) {
              otherEvents.push(events[i]);
            }
          }

          self.userEvents = attending;
          self.otherEvents = otherEvents;
          self.loading = false;
        };

        self.goToEvent = function(id) {
          self.navigation.goTo('/#/view/events/' + id);
        };

        self.initialize = function () {
          self.loading = true;
          var today = moment();
          Events.find({
            start_date: '$gt,date-' + today.format('MM-DD-YY') + ',$lte,date-' + today.add(7, 'days').format('MM-DD-YY')
          }, function (data) {
            parseEvents(data);
          }, function (error) {
            console.log('Error occured getting events ', error);
            Application.notifications.setError(self.translations['modules.notifications.unableToGetEvent']);
          });
        };

        $translate(['modules.notifications.unableToGetEvent']).then(function(translations){
          self.translations = translations;
          self.initialize();
        });
      },
      controllerAs: 'events'
    };
  }]);

